app.factory(
    'GroupService', ['LocalStorage', 'ApiService', '$rootScope', GroupService]
);

function GroupService(LocalStorage, ApiService, $rootScope) {
    self.GetAll = GetAll;
    self.GetGroup = GetGroup;
    self.GetGroupForCreation = GetGroupForCreation;
    self.CreateNewGroup = CreateNewGroup;
    self.UpdateGroup = UpdateGroup;
    self.UpdateDescription = UpdateDescription;
    self.TranslateGroup = TranslateGroup;
    self.GetGroupList = GetGroupList;

    function GetAll() {
        return ApiService.get('/api/groupAPI/GetAllGroups').then(handleSuccess, handleError('Error getting all Groups'));
    }

    function GetGroup(id, qc, lang, lang2, index, sortKey, reverse) {
        return ApiService.get('/api/groupAPI/GetGroup?id=' + id + "&qc=" + qc + "&lang=" + lang + "&lang2=" + lang2 + "&index=" + index + "&sortKey=" + sortKey + "&reverse=" + reverse).then(handleSuccess, handleError('Error getting Group by id'));
    }

    self.GetGroupPreview = function (id, lang) {
        return ApiService.get('/api/groupAPI/GetGroupPreview?id=' + id + "&lang=" + lang).then(handleSuccess, handleError('Error getting Group Preview'));
    }

    //Get  Group List
    function GetGroupList(zoneId, qcId, itemsPerPage, pagenumber, sortKey, reverse, lang, isTopBarActive,sparams, sgparams,searchText, AdvancedSearch) {
        var request = ApiService.post("/api/groupAPI/GetGroupList?zoneId=" + zoneId + "&qc=" + qcId + "&itemsPerPage=" + itemsPerPage + "&pagenumber=" + pagenumber + "&sortKey=" + sortKey + "&reverse=" + reverse + "&lang=" + lang + "&itba=" + isTopBarActive + "&sparams=" + sparams + "&sgparams=" + sgparams + "&st=" + encodeURIComponent(searchText), AdvancedSearch);
        return request;
    }

    //Update  
    function UpdateGroup(Group) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(Group);
        var request = ApiService.post("/api/GroupApi/UpdateGroupTranslation?id=" + Group.GroupId, st)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Translate Group    
    function TranslateGroup(Group) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/GroupApi/TranslateGroup",Group)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Create
    function CreateNewGroup(GroupVm) {
        var st = JSON.stringify(GroupVm);
        var request = ApiService.post("/api/GroupApi/CreateNewGroup", st);
        return request;
    }

    //GetGroupForCreation
    function GetGroupForCreation(qc, lang) {
        var request = ApiService.get("/api/GroupApi/GetGroupForCreation?qc=" + qc + "&lang=" + lang).then(handleSuccess, handleError('Error Create new Group'));
        return request;
    }

    //Create New Description and associate with Group
    self.CreateNewDescriptionForGroup = function (descForCreation) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(descForCreation);
        var request = ApiService.post("/api/DescriptionApi/CreateNewDescriptionForObject/", st)
            .then(
                function success(data) {
                    $rootScope.returnNewDesc = angular.copy(data.data);
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }    

    // private functions

    function handleSuccess(res) {
        return res.data;
    }

    function handleError(error) {
        return function () {
            return { success: false, message: error };
        };
    }


    return self;
}